
define(
	'Digi.TrialItemDefaultQuantity.TrialItemDefaultQuantity',
	[],
	function ()
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {

			var pdp;
			var cart;
			var layout;
			var environment;
			var config;
			var defaultQuantity;
			var trialItemId;
			var trialItemErrMessage;
			// var ProductDetailsQuantityView;

			pdp = container.getComponent('PDP');
			cart = container.getComponent('Cart');
			layout = container.getComponent('Layout');
			environment = container.getComponent('Environment');

			config = environment.getConfig('digiConfigSettings');

			defaultQuantity = config && config.trialItem && config.trialItem.defaultQuantity;
			trialItemId = config && config.trialItem && config.trialItem.itemId;
			trialItemErrMessage = config && config.trialItem && config.trialItem.errorMessage;

			if (pdp) {

				pdp.on('beforeShowContent', function () {

					var itemInfo;

					itemInfo = pdp.getItemInfo();

					if (itemInfo && itemInfo.item && itemInfo.item.internalid === trialItemId) {
						pdp.setQuantity(defaultQuantity);
					}
				});
			}

			if (cart) {

				function validateTrialItem(data) {

					var promise = jQuery.Deferred();
					var trialItem;
					var newItemId;

					cart.getLines().done(function (lines) {

						trialItem = _.filter(lines, function (line) {
							return line.item && line.item.internalid === trialItemId;
						});

						newItemId = data && data.line && data.line.item && data.line.item.internalid;

						console.log('lines', lines);
						console.log('data', data);

						if (trialItem && trialItem.length && (newItemId === trialItemId)){
							promise.reject({
								responseText: JSON.stringify({
									message: trialItemErrMessage || 'This item is already in your cart.',
									errorDetails: { newLineId: data.line.internalid }
								}),
								responseJSON: { errorCode: 'ERR_EXT_CANCELED_OPERATION' }
							});
						} else {
							promise.resolve();
						}
					})

					return promise;
				};

				cart.on('beforeAddLine', function (data) {
					return validateTrialItem(data)
				});

				cart.on('beforeUpdateLine', function (data) {
					return validateTrialItem(data)
				});
			}

			if (layout) {

				// Adds new context variable. Theme template modified to include logic.
				layout.addToViewContextDefinition('ProductDetails.Quantity.View', 'isComingSoon', 'boolean', function (context) {
					var item;
					item = context && context.model && context.model.item;
					return item && item.internalid === 33405;
				});
				layout.addToViewContextDefinition('Cart.Item.Summary.View', 'isComingSoon', 'boolean', function (context) {
					var item;
					item = context && context.model && context.model.item;
					return item && item.internalid === 33405;
				});
				layout.addToViewContextDefinition('Cart.Item.Actions.View', 'isComingSoon', 'boolean', function (context) {
					var item;
					item = context && context.model && context.model.item;
					return item && item.internalid === 33405;
				});


				// Adds new context variable. Theme template modified to include logic.
				layout.addToViewContextDefinition('ProductDetails.Quantity.View', 'isTrialItem', 'boolean', function (context) {

					var item;

					item = context && context.model && context.model.item;

					return item && item.internalid === trialItemId;
				});

				// Adds new context variable. Theme template modified to include logic.
				layout.addToViewContextDefinition('Cart.Item.Summary.View', 'isTrialItem', 'boolean', function (context) {

					var item;

					item = context && context.line && context.line.item;

					return item && item.internalid === trialItemId;
				});

				// Adds new context variable. Theme template modified to include logic.
				layout.addToViewContextDefinition('Cart.Item.Actions.View', 'isTrialItem', 'boolean', function (context) {

					var item;

					item = context && context.line && context.line.item;

					return item && item.internalid === trialItemId;
				});
			}

			// ProductDetailsQuantityView = require('ProductDetails.Quantity.View');

			// if (
			// 	ProductDetailsQuantityView
			// 	&& ProductDetailsQuantityView.prototype
			// 	&& _.isFunction(ProductDetailsQuantityView.prototype.initialize)
			// ) {
			// 	ProductDetailsQuantityView.prototype.initialize = _.wrap(ProductDetailsQuantityView.prototype.initialize, function (fn) {
			// 		var self;
			// 		var item;

			// 		fn.apply(this, _.toArray(arguments).slice(1));

			// 		self = this;
			// 		item = this.model.get('item');

			// 		this.on('afterViewRender', function () {
			// 			if (item.get('internalid') === 33429) {
			// 				self.$('.product-details-quantity-value').prop('disabled', true);
			// 			}
			// 		});
			// 	})
			// }
		}
	};
});
